import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TrendVolumeMain from '../../presentation/section/trend-page/TrendVolumeMain';
import { getExpressParams } from '../../../service/api';
import JSONtoTrendData from '../json-to-chartdata/JSONtoTrendData';
import TrendDetailMain from '../../presentation/section/trend-page/TrendDetailMain';

const TrendDetail = (props) => {
  const history = useHistory();
  // const [trendQuery, setTrendQuery] = useState('');
  const [trendQueries, setTrendQueries] = useState(['']);
  const [dateRange, setDate] = useState([new Date(), new Date()]);
  const [onDateBtn, setOnDateBtn] = useState('nope')
  const [onTimeUnitBtn, setOnTimeUnitBtn] = useState('daily');
  const [resultData, setResultData] = useState(null);
  const [responseData, setResponseData] = useState(null);

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selections, setSelections] = useState({});

  const naverMinDate = new Date(2016, 0);

  useEffect(() => {
    if (props.currentRole != 'ROLE_ADMIN') {
      history.goBack();
    }
  }, [])

  useEffect(() => {
    if (!resultData && !responseData) {
    }
    else {
      setResultData(JSONtoTrendData(responseData, "detail", { timeunit: onTimeUnitBtn, selections: selections }));
    }
  }, [onTimeUnitBtn])

  const handleAddQuery = () => {
    const MAX_QUERIES = 5; // 최대 검색어 개수 제한

    if (trendQueries.length < MAX_QUERIES) {
      setTrendQueries([...trendQueries, '']);
    } else {
      alert(`검색어는 최대 ${MAX_QUERIES}개까지 입력할 수 있습니다.`);
    }
  };

  const handleRemoveQuery = (index) => {
    const newQueries = trendQueries.filter((_, i) => i !== index);
    setTrendQueries(newQueries.length > 0 ? newQueries : ['']);
  };

  const handleQueryChange = (index, event) => {
    const newQueries = [...trendQueries];
    newQueries[index] = event.target.value;
    setTrendQueries(newQueries);
  };

  const handleRunBtn = () => {
    // const setTrendQueryList = () => {
    //   let retArr = [];
    //   retArr.push(trendQuery)

    //   return retArr;
    // }
    // const trendQueryList = setTrendQueryList();

    const trendQueryList = trendQueries.filter(query => query.trim() !== '');

    setResultData(null);
    setResponseData(null);

    getExpressParams(`/trend/detail/json`, {
      email: props.currentUser,
      json: {
        trendQueryList: trendQueryList,
        dateRange: [(dateRange[0].toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" })).replace(/\//g, ""),
        (dateRange[1].toLocaleDateString("ja-JP", { year: "numeric", day: "2-digit", month: "2-digit" })).replace(/\//g, "")],
        timeunit: onTimeUnitBtn
      }
    }, (response) => {
      setResponseData(response.data)
      setResultData(JSONtoTrendData(response.data, "detail", { timeunit: onTimeUnitBtn, selections: selections }));
    })
  }

  const handleDate = (selectedDateRange) => {
    setDate(selectedDateRange)
  }

  const handleTimeUnitBtn = (e) => {
    const dateUnit = e.target.getAttribute('name');

    switch (dateUnit) {
      case "daily": {
        setOnTimeUnitBtn("daily")
        break;
      }
      case "weekly": {
        setOnTimeUnitBtn("weekly")
        break;
      }
      case "monthly": {
        setOnTimeUnitBtn("monthly")
        break;
      }
      default:
        break;
    }
  }

  const handleDateBtn = (e) => {
    const date = e.target.getAttribute('name');
    let end_date = new Date();
    end_date.setFullYear(end_date.getFullYear(), end_date.getMonth(), end_date.getDate() - 1);

    if (props.currentRole == 'ROLE_USER_04') {
      let start_date = new Date();
      start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate() - 7);
      setDate([start_date, end_date]);
      setOnDateBtn("w1")
      return;
    }

    switch (date) {
      case "1week": {
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate() - 7);
        setDate([start_date, end_date]);
        setOnDateBtn("w1")
        break;
      }
      case "2week": {
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth(), start_date.getDate() - 14);
        setDate([start_date, end_date]);
        setOnDateBtn("w2")
        break;
      }
      case "1month": {
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth() - 1);
        setDate([start_date, end_date]);
        setOnDateBtn("m1")
        break;
      }
      case "3month": {
        let start_date = new Date();
        start_date.setFullYear(start_date.getFullYear(), start_date.getMonth() - 3);
        setDate([start_date, end_date]);
        setOnDateBtn("m3")
        break;
      }
      default:
        break;
    }
  }

  // const handleTrendQuery = (e) => {
  //   setTrendQuery(e.target.value)
  // }

  const handleSelectionChange = (newSelection) => {
    setSelections(newSelection);
  };

  return (
    <>
      <TrendDetailMain dateRange={dateRange} onDateBtn={onDateBtn} handleDateBtn={handleDateBtn} handleDate={handleDate} minDate={naverMinDate}
        // handleTrendQuery={handleTrendQuery} trendQuery={trendQuery}
        handleTimeUnitBtn={handleTimeUnitBtn} onTimeUnitBtn={onTimeUnitBtn}
        handleRunBtn={handleRunBtn} resultData={resultData} userRole={props.currentRole}
        handleSelectionChange={handleSelectionChange}
        handleQueryChange={handleQueryChange} trendQueries={trendQueries}
        handleAddQuery={handleAddQuery} handleRemoveQuery={handleRemoveQuery}
      />
    </>
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole: state.AuthManager.status.currentRole
})

export default connect(mapStateToProps)(TrendDetail);